import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMaritalStatus } from "../actions/maritalStatusActions";

const MaritalStatus = React.memo(() => {
  const dispatch = useDispatch();

  const maritalStatusList = useSelector((state) => state.maritalStatusList);
  const { maritalstatuss, loading, error } = maritalStatusList;

  useEffect(() => {
    if (!maritalstatuss) {
      dispatch(getMaritalStatus());
    }
  }, [maritalstatuss]);
  return (
    <>
      {loading ? (
        <>loading...</>
      ) : (
        <>
          {maritalstatuss ? (
            maritalstatuss.map((maritalstatu, i) => (
              <option key={maritalstatu.Id} value={maritalstatu.Id}>
                {maritalstatu.MaritalStatus}
              </option>
            ))
          ) : (
            <>
              <option>Loading...</option>
            </>
          )}
        </>
      )}
    </>
  );
});

export default MaritalStatus;
